<template>
    <div :class="containerClass" @click="onWrapperClick" :style="theme">
        <div id="offline_banner" v-if="connected === false">
            Connection Lost<i class="pi pi-ban" style="font-size: 2rem"></i>
        </div>
        <div id="online_banner" v-if="showBackOnline && connected">
            Back Online<i class="pi pi-check" style="font-size: 2rem"></i>
        </div>
        <Button id="scanButton" label="Enable NFC" style="display:none; position: absolute; bottom: 2rem; right: 2rem;" icon="pi pi-external-link" @click="NFCButtonVisible = true" />

        <template v-if="this.user.loggedIn && this.$route.name != 'checkinout' && this.$route.name != 'checksuccess' && this.$route.name != 'scan'">
            <AppTopBar @menu-toggle="onMenuToggle" v-if="user.loggedIn && user.data.active && this.$route.name != 'checkinout' && this.$route.name != 'checksuccess' && this.$route.name != 'scan'" />
            <transition name="layout-sidebar" v-if="this.$route.name != 'checkinout' && this.$route.name != 'checksuccess' && this.$route.name != 'scan'">
                <div :class="sidebarClass" @click="onSidebarClick" v-show="isSidebarVisible()">
                    <AppProfile />
                    <AppMenu :model="menu" :binFields="binFields" @menuitem-click="onMenuItemClick" />
                </div>
            </transition>
        </template>

        <div class="layout-main">
            <transition>
                <router-view v-if="connected" :user="user.data" :clientId="clientId"
                    :isOnline="connected" />
                <router-view v-else :isOnline="connected" />
            </transition>
            <CookieNotice v-if="!this.$cookie.get('cookie_consent') == '1'"></CookieNotice>
        </div>

        <AppFooter v-if="this.$route.name != 'checkinout' && this.$route.name != 'checksuccess' && this.$route.name != 'scan'" />

        <Toast />
    </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppProfile from './AppProfile.vue';
import AppMenu from './AppMenu.vue';
import AppFooter from './AppFooter.vue';
import axios from 'axios';
import { mapGetters } from "vuex";
import CookieNotice from './components/CookieNotice.vue';
import store from './stores/store.js';
import { db } from '@/firebase';

export default {
    data() {
        return {
            showBackOnline: false,
            layoutMode: 'static',
            layoutColorMode: 'dark',
            staticMenuInactive: true,
            overlayMenuActive: false,
            mobileMenuActive: false,
            client: null,
            clientId: '',
            menu: [
                { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
                // { label: 'Clients', icon: 'pi pi-fw pi-list', to: '/clients', access: 10 },
                // { label: 'Templates', icon: 'pi pi-fw pi-th-large', to: '/templates', access: 6 },
                { label: 'Users', icon: 'pi pi-fw pi-user', to: '/users' },
            ],
            binFields: [

            ],
            textDark: '#000000',
            textLight: '#ffffff',
            theme: {
                '--primary-button-color': '#0388E5',
                '--button-text-color': '#ffffff',
                '--link-text-color': '#0388E5'
            }
        }
    },
    created() {
        this.isOnline = true;
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
        if (this.user.loggedIn && (this.user.auth.accessToken !== null || typeof this.user.auth.accessToken !== "undefined")) {
            this.initClient();
            this.userData();
        }
        window.addEventListener('online', this.updateOnlineStatus);
        window.addEventListener('offline', this.updateOnlineStatus);
    },
    mounted() {
        if (this.user) {  // remove store items if user doesn't exist in firestore
            db.collection('users').doc(this.user.data.email).get().then((user) => {
                if (!user.exists) {
                    localStorage.removeItem('vuex');
                    localStorage.removeItem('site-asset-data');
                    store.dispatch("fetchUser", null);
                    this.$router.push('login');
                }
            })
        }
    },
    beforeDestroy() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
    },
    watch: {
        $route(to, from) {
            this.menuActive = false;
            // this.$toast.removeAllGroups();
            if ((this.user.loggedIn && !this.$route.matched.some(route => route.path.includes('/check-'))) || !this.user.loggedIn) {
                this.isSidebarVisible;
            } else {
                this.layoutMode = 'static';
            }

            if ((to.name == 'dashboard') && (from.name == 'login')) {
                this.initClient();
                this.userData();
            }
            if ((to.name == 'login') && !this.user.loggedIn) {
                this.menu = [
                    { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/' },
                    { label: 'Users', icon: 'pi pi-fw pi-user', to: '/users' },
                ]
                this.theme = {
                    '--primary-button-color': '#0388E5',
                    '--button-text-color': '#ffffff',
                    '--link-text-color': '#0388E5'
                }
            }
        },
        connected(v) {
            console.log({ "isOnline": v });
            if (v) { // if back online is true
                this.showBackOnline = true;
                setTimeout(() => {
                    this.showBackOnline = false;
                }, 1000);
                // if any info is stored, submit maintenance information
                let currentStoredData = JSON.parse(sessionStorage.getItem('stored-maintenance-data'));
                let currentStoredAttendance = JSON.parse(sessionStorage.getItem('stored-attendance-data'));

                if (currentStoredData && currentStoredAttendance) { // only submit if both records exist - always should be the same amount of records
                    currentStoredData.forEach((record, index) => {
                        console.log(index)
                        record.meta.last_maintained_date = this.parseISOString(record.meta.last_maintained_date);
                        record.meta.first_maintained_date = (typeof (record.meta.first_maintained_date) == 'string') ? this.parseISOString(record.meta.first_maintained_date) : record.meta.first_maintained_date;
                        currentStoredAttendance[index].timestamp = this.parseISOString(currentStoredAttendance[index].timestamp)

                        db.collection('assets').doc(record.asset_id).update(record.meta);
                        db.collection('attendance').add(currentStoredAttendance[index]);
                    });

                    sessionStorage.removeItem('stored-maintenance-data');
                    sessionStorage.removeItem('stored-attendance-data');
                    this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Stored maintenance information submitted.', life: 6000 });

                }

                this.submitStoredFaultData() // function to push fault data submitteed while offline

            }
        },
    },
    methods: {
        async initClient() {
            axios({
                method: 'post',
                url: process.env.VUE_APP_API_URL + '/init/client',
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: {
                    client_id: this.user.data.client.key
                }
            }).then((response) => {
                this.client = response.data;
                this.cssVars(response.data)
            }).catch(error => { console.error(error) });
        },
        parseISOString(s) {
            if (!s || typeof s !== 'string') {
                return new Date();
            }
            try {
                var b = s.split(/\D+/);
                if (b.length < 6) {
                    return new Date();
                }
                return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
            } catch (error) {
                console.warn('Invalid date string:', s, error);
                return new Date();
            }
        },
        userData() {
            if ((!this.user.data.active) && this.$route.meta.requiresAuth) {
                this.$router.replace({ path: '/unauthorised' })
            } else {
                if (this.$store.getters.user.data.client) {
                    if (this.user.data.role.permissionLevel == 10) {
                        this.menu.splice(1, 0, { label: 'Clients', icon: 'pi pi-fw pi-list', to: '/clients', access: 10 })
                        if(!this.binFields.length) { // checks if bin fields already exist
                            this.binFields.push({ label: 'Asset Bin', to: '/asset-bin/' + this.user.data.client.key.trim(), access: 10 })
                            this.binFields.push({ label: 'Site Bin', to: '/site-bin/' + this.user.data.client.key.trim(), access: 10 })
                            this.binFields.push({ label: 'Report Bin', to: '/report-bin/' + this.user.data.client.key.trim(), access: 10 })
                        }
                    }
                    if (this.user.data.role.permissionLevel >= 8) {
                        this.menu.splice(8, 0, { label: 'Reporting', icon: 'pi pi-fw pi-file', to: '/custom-reports/' + this.user.data.client.key.trim(), access: 8 })
                        this.menu.splice(8, 0, { label: 'Settings', icon: 'pi pi-fw pi-cog', to: '/settings/' + this.user.data.client.key.trim(), access: 8 })
                    }
                    if (this.user.data.client) {
                        this.menu.splice(1, 0, { label: this.user.data.client.name, icon: 'pi pi-fw pi-building', to: '/sites/' + this.user.data.client.key.trim(), dynamic: true })
                    }
                }
                if (this.$route.path == '/unauthorised') {
                    this.$router.replace({ path: '/' })
                }
            }
        },
        async UpdateFirebase() {
            const getUserData = db.collection('users').doc(this.$store.getters.user.data.user.email);
            const userDoc = await getUserData.get();
            const setUserData = userDoc.data();
            const getClientData = db.collection('clients').doc(setUserData.client.key);
            const clientDoc = await getClientData.get();
            const setClientData = clientDoc.data();

            this.userClient = setClientData;
            this.clientId = clientDoc.id;
        },
        onWrapperClick() {
            if (!this.menuClick) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }

            this.menuClick = false;
        },
        onMenuToggle() {
            this.menuClick = true;

            if (this.isDesktop()) {
                if (this.layoutMode === 'overlay') {
                    if (this.mobileMenuActive === true) {
                        this.overlayMenuActive = true;
                    }

                    this.overlayMenuActive = !this.overlayMenuActive;
                    this.mobileMenuActive = false;
                }
                else if (this.layoutMode === 'static' && this.user.loggedIn) {
                    this.staticMenuInactive = !this.staticMenuInactive;
                }
            }
            else {
                this.mobileMenuActive = !this.mobileMenuActive;
            }

            event.preventDefault();
        },
        onSidebarClick() {
            this.menuClick = true;
        },
        onMenuItemClick(event) {
            if (event.item && !event.item.items) {
                this.overlayMenuActive = false;
                this.mobileMenuActive = false;
            }
        },
        onLayoutColorChange(layoutColorMode) {
            this.layoutColorMode = layoutColorMode;
        },
        addClass(element, className) {
            if (element.classList)
                element.classList.add(className);
            else
                element.className += ' ' + className;
        },
        removeClass(element, className) {
            if (element.classList)
                element.classList.remove(className);
            else
                element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        },
        isDesktop() {
            return window.innerWidth > 1024;
        },
        isSidebarVisible() {
            if (this.isDesktop()) {
                if (this.layoutMode === 'static' && !this.user.loggedIn)
                    return !this.staticMenuInactive;
                else if (this.layoutMode === 'overlay')
                    return this.overlayMenuActive;
                else
                    return true;
            }
            else {
                return true;
            }
        },
        cssVars(client) {
            var primaryColour = '0388E5',
                secondaryColour = '0388E5',
                hex = '0388E5';

            if (this.user.loggedIn) {
                if (client) {
                    let r, g, b;
                    if (client.secondaryColour) {
                        secondaryColour = client.secondaryColour
                        hex = client.secondaryColour;
                        r = parseInt(hex.slice(0, 2), 16),
                            g = parseInt(hex.slice(2, 4), 16),
                            b = parseInt(hex.slice(4, 6), 16);
                    }
                    if (client.primaryColour) {
                        primaryColour = client.primaryColour

                    }
                    var colourClass = ((r * 0.299 + g * 0.587 + b * 0.114) > 220) ? this.textDark : this.textLight;
                    var linkClass = ((r * 0.299 + g * 0.587 + b * 0.114) > 220) ? primaryColour : secondaryColour;
                    // debugger
                    this.theme = {
                        '--primary-button-color': '#' + primaryColour,
                        '--button-text-color': colourClass,
                        '--link-text-color': '#' + linkClass
                    }
                }
            }
        },
        updateOnlineStatus(e) {
            const { type } = e;
            if (type === 'online') {
                this.isOnline = true;
            } else {
                this.isOnline = false;
            }
        },
        submitStoredFaultData() {
            let currentStoredFaultData = JSON.parse(sessionStorage.getItem('stored-fault-asset-data'));

            if (currentStoredFaultData) { // only submit if both records exist - always should be the same amount of records
                currentStoredFaultData.forEach((record, index) => {
                    let fault_report_note = record.fault_report_note.replaceAll('\n', ' - ');
                    fault_report_note = fault_report_note.replaceAll(',', ' - ');
                    const fault_reporter_name = record.fault_reporter_name.replaceAll(',', ' - ')
                    const fault_reporter_company = record.fault_reporter_company.replaceAll(',', ' - ')

                    const reportFaultEndpoint = process.env.VUE_APP_API_URL + '/fault-report'

                    axios({
                        method: 'post',
                        url: reportFaultEndpoint,
                        data: {
                            // all these are required to hit this function, so shouldn't be a problem
                            // for offline pushes, i'm happy to leave the timestamp as the server says, as technically it's the time the status was updated
                            'asset_id': record.asset_id,
                            'site_id': record.site_id,
                            'client_id': record.client_id,
                            'fault_status': record.fault_status,
                            'notes': fault_report_note,
                            'reporter_name': fault_reporter_name,
                            'reporter_company': fault_reporter_company,
                            'fault_id':  record.fault_id
                        }
                    }).then((response) => {
                    }).catch(error => { console.error(error) });
                });

                sessionStorage.removeItem('stored-fault-asset-data');
                this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Stored maintenance information submitted.', life: 6000 });

            }
        }
    },
    computed: {
        ...mapGetters({
            user: "user",
            connected: "connected"
        }),
        containerClass() {
            return ['layout-wrapper', {
                'layout-overlay': this.layoutMode === 'overlay',
                'layout-static': this.layoutMode === 'static' && this.user.loggedIn,
                // 'layout-static-sidebar-inactive': this.staticMenuInactive && this.layoutMode === 'static',
                'layout-overlay-sidebar-active': this.overlayMenuActive && this.layoutMode === 'overlay',
                'layout-mobile-sidebar-active': this.mobileMenuActive,
                'p-input-filled': this.$appState.inputStyle === 'filled',
                // 'p-ripple-disabled': this.$primevue.ripple === false,
                'layout-checkinout': this.$route.name === 'checkinout',
                'layout-scan': this.$route.name === 'scan',
                'layout-checkinout layout-checkinout-success': this.$route.name === 'checksuccess'
            }];
        },
        sidebarClass() {
            return ['layout-sidebar', {
                'layout-sidebar-dark': this.layoutColorMode === 'dark',
                'layout-sidebar-light': this.layoutColorMode === 'light'
            }];
        }
    },
    beforeUpdate() {
        if (this.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    },
    components: {
        'AppTopBar': AppTopBar,
        'AppProfile': AppProfile,
        'AppMenu': AppMenu,
        'AppFooter': AppFooter,
        CookieNotice
    }
}
</script>

<style lang="scss">
@import './App.scss';

#offline_banner {
    position: fixed;
    z-index: 1000000;
    background: red;
    width: 100vw;
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    color: white;
    font-size: 20px;
}

#online_banner {
    position: fixed;
    z-index: 1000000;
    background: #4BB543;
    width: 100vw;
    padding: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    color: white;
    font-size: 20px;
}

.v-enter-active,
.v-leave-active {
    transition: opacity .5s ease;
}

.v-enter-active {
    transition-delay: 0.5s;
}

.v-enter,
.v-leave-active {
    opacity: 0;
}
</style>
